import Model from '@/store/plugins/orm/Model'
import ApiService from '@/services/ApiService';
import { Sector, Order, KitchenTicket, AppEvent } from './ModelRepository'

export class Table extends Model {
    static get entity() {
        return 'tables';
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            color: this.attr(null),
            height: this.attr(null),
            width: this.attr(null),
            shape: this.attr(null),
            pos_left: this.attr(null),
            pos_top: this.attr(null),
            sector_id: this.attr(null),

            sector: this.belongsTo(Sector, 'sector_id'),
            orders: this.hasMany(Order, 'table_id'),

            sync_needed: this.attr(null)
        };
    }

    /**
     * Make a copy of the table.
     */
    $duplicate() {
        return new Table(this.$toJson());
    }

    async transferToTable(table) {
        if (!this.$store().getters.isOnline) {
            return { error: 'offline' };
        }

        const response = await ApiService.post(`/tables/${this.id}/transfer`, { dst_table: table.id });

        if(response.data.orders.length) {
            Order.insert({ data: response.data.orders, freeze: true });
            AppEvent.build('ordersSync', {
                items: response.data.orders.map(record => ({ action: 'patch', record }))
            }).send()
        }

        if(response.data.kitchen_tickets.length) {
            KitchenTicket.insert({ data: response.data.kitchen_tickets });
            AppEvent.build('kitchenTicketsSync', {
                items: response.data.kitchen_tickets.map(record => ({ action: 'patch', record }))
            }).send()
        }

        return { success: true };
    }
}

export default Table
